<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
      <sui-grid
        ref="grdList"
        :showCountControl="true"
        :showDisplayCountControl="false"
        :pageable="false"
        :sortable="false"
        :filterable="false"
        :columns="gridColumns"
        :columnsresize="true"
        :columnsautoresize="true"
        :enabletooltips="true"
        width="100%"
        :dataset="'dsData'"
        :initialPagesize="15"
        @columnclick="onSelectAll"
      />
      <div class="comm_btn_wrap">
        <sui-button
          type="button"
          class="comm_btn_solid"
          @click="onCancel"
        >
          {{ $t('MSG_BTN_APPL_CNCL') }}
        </sui-button>
      </div>
    </sui-page-contents>
  </sui-page>
</template>
<script>
// import - libraries (node modules)
// import - local files (js, vue, ...)
// 페이지 에서 사용하는 code 목록 기술
const codeKeys = ['COD_AUTH_RQS_STT'];
export default {
  name: 'PGE_CMA_00006', // eslint-disable-line vue/name-property-casing
  data() {
    return {
      allSelect: false,
      userInfo: {},
      stateOptionList: [],
      codes: {
        COD_AUTH_RQS_STT: [{ label: '', key: '' }],
      },
      localdata0: [],
      gridColumns: [
      {
        text: '',
        datafield: 'check',
        align: 'center',
        width: '40',
/*
        renderer: function(elem) {
          return '<div id="checkbox" style="z-index: 999; margin-top: 8px; margin-left:8px" @click="onSelectAll"></div>';
        },
        rendered: function(element, align, height) {
          element.jqxCheckBox();
        },
*/
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellCheckbox(row, column, value, htmlElement, {
          }, this.dsData, this.$refs.grdList);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      },
      {
        text: this.$t('MSG_TXT_TASK_TYPE'),
        datafield: 'taskName',
      },
      {
        text: this.$t('MSG_TXT_USER_GROUP'),
        datafield: 'userGroupName',
      },
      {
        text: this.$t('MSG_TXT_APPL_CNTN'),
        datafield: 'button',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellButtonList(row, column, value, htmlElement, {
            handler: this.onGridSingleButtonClicked,
          }, this.dsData, this.$refs.grdList);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
        cellsalign: 'left',
        width: '100px',
      },
      {
        text: this.$t('MSG_TXT_APPL_DTM'),
        datafield: 'requestDTM',
        width: 150,
      },
      {
        text: this.$t('MSG_TXT_APPR_STT'),
        datafield: 'authRequestStatusCode',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellBadge(row, column, value, htmlElement, {
            optionList: this.stateOptionList, handler: this.onGridStateClicked,
          }, this.dsData, this.$refs.grdList);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
        width: 100,
      }, {
        text: this.$t('MSG_TXT_APPR_RJT_USER'),
        datafield: 'authUserId',
        createwidget: (row, column, value, htmlElement) => {
          if (utils.isEmpty(row.bounddata.authUserId) === false) {
            utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement, {
              displayType: '1', // "1", "2" - default: "1"
              type: 'link', // 'link', 'sublink' - default: "link"
              datafieldMap: {
                displayLanguageId: 'authDsplLangId',
                knoxId: 'authKnoxId',
                loginId: 'authLoginId',
                userName: 'authUserName',
                userGlobalName: 'authUserGlobalName',
              },
            }, this.dsData, this.$refs.grdList);
          }
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
        width: 200,
      },
      {
        text: this.$t('MSG_TXT_APPR_RJT_USER_DTM'),
        datafield: 'authApprDTM',
        width: 150,
      }],
    };
  },
  computed: {},
  watch: {},
  datasets: [{
    id: 'dsData',
    type: 'local',
    data: 'localdata0',
    datafields: [
//      { name: 'dataset-row-id', type: 'string', map: 'dataset-row-id' },
      { name: 'check', type: 'string', map: 'check' },
      { name: 'taskId', type: 'string', map: 'taskId' },
      { name: 'taskName', type: 'string', map: 'taskName' },
      { name: 'userGroupId', type: 'string', map: 'userGroupId' },
      { name: 'userGroupName', type: 'string', map: 'userGroupName' },
      { name: 'requestUserId', type: 'string', map: 'requestUserId' },
      { name: 'requestUserName', type: 'string', map: 'requestUserName' },
      { name: 'requestUserGlobalName', type: 'string', map: 'requestUserGlobalName' },
      { name: 'requestDeptId', type: 'string', map: 'requestDeptId' },
      { name: 'requestDeptName', type: 'string', map: 'requestDeptName' },
      { name: 'requestDeptGlobalName', type: 'string', map: 'requestDeptGlobalName' },
      { name: 'requestDsplLangId', type: 'string', map: 'requestDsplLangId' },
      { name: 'requestKnoxId', type: 'string', map: 'requestKnoxId' },
      { name: 'button', type: 'string', map: 'button' },
      { name: 'authRequestReason', type: 'string', map: 'authRequestReason' },
      { name: 'authApprDTM', type: 'string', map: 'authApprDTM' },
      { name: 'authRequestStatusCode', type: 'string', map: 'authRequestStatusCode' },
      { name: 'authRequestStatusName', type: 'string', map: 'authRequestStatusName' },
      { name: 'authRejectUserId', type: 'string', map: 'authRejectUserId' },
      { name: 'authRejectReason', type: 'string', map: 'authRejectReason' },
      { name: 'authRejectDtm', type: 'string', map: 'authRejectDtm' },
      { name: 'authRejectUserIp', type: 'string', map: 'authRejectUserIp' },
      { name: 'authUserId', type: 'string', map: 'authUserId' },
      { name: 'authUserName', type: 'string', map: 'authUserName' },
      { name: 'authUserGlobalName', type: 'string', map: 'authUserGlobalName' },
      { name: 'authDsplLangId', type: 'string', map: 'authDsplLangId' },
      { name: 'authKnoxId', type: 'string', map: 'authKnoxId' },
      { name: 'authLoginId', type: 'string', map: 'authLoginId' },
      { name: 'authRequestUid', type: 'string', map: 'authRequestUid' },
      { name: 'requestDTM', type: 'string', map: 'requestDTM' },
    ],
  }],
  mounted() {
    this.loadCode().then(() => {
      this.load();
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    loadCode() {
      return http.mergeCodeList(this.$options.name, codeKeys, this.codes).then(res => {
        this.stateOptionList = [];
        utils.forEach(res.COD_AUTH_RQS_STT, item => {
          let codeType = '';
          let clickable = '';
          switch (item.key) {
            case 'S':
              // 신청
              codeType = 'waiting';
              clickable = '';
              break;
            case 'A':
              // 승인
              codeType = 'complete';
              clickable = '';
              break;
            case 'R':
              // 반려
              codeType = 'cancel';
              clickable = 'true';
              break;
            case 'Z':
              // 신청 취소
              codeType = 'cancel';
              clickable = '';
              break;
            default:
              break;
          }
          this.stateOptionList.push({
            label: item.label,
            key: item.key,
            type: codeType,
            clickable,
          });
        });
      }).catch(error => {
        console.log(error);
      });
    },
    load() {
      this.userInfo = this.$store.getters.userInfo;
      this.searchData();
    },
    searchData() {
      http.request(this.$options.name, 'DTS_CMA_00036', {
      }).then(res => {
        const items = [];
        utils.forEach(res.data, item => {
          const apprDTM = utils.isEmpty(item.authApprovalDTM) === true
            ? '-' : utils.dateformatToClient(item.authApprovalDTM);
          const requestDTM = utils.dateformatToClient(item.firstRegistrationDTM);
          const check = item.authRequestStatusCode === 'S' ? 'N' : 'O';
          const button = item.authRequestStatusCode === 'S' ? [{ label: this.$t('MSG_BTN_INQR'), type: 'positive' }] : [];
          items.push({
            check,
            taskId: item.taskId,
            taskName: item.taskName,
            userGroupId: item.userGroupId,
            userGroupName: item.userGroupName,
            requestUserId: item.userId,
            requestUserName: item.userName,
            requestUserGlobalName: item.userGlobalName,
            requestDsplLangId: item.displayLangId,
            requestKnoxId: item.knoxId,
            button: button,
            authRequestStatusCode: item.authRequestStatusCode,
            authRequestReason: item.authApprovalOpinionContent,
            authRejectReason: item.authApprovalOpinionContent,
            authApprDTM: apprDTM,
            authUserId: item.authApprovalUserId,
            authUserName: item.authApprovalUserName,
            authUserGlobalName: item.authApprovalUserGlobalName,
            authDsplLangId: item.authApprovalDisplayLangId,
            authKnoxId: item.authApprovalKnoxId,
            authLoginId: item.authApprovalLoginId,
            authRequestUid: item.authRequestUid,
            requestDTM: requestDTM,
          });
        });
        this.dsData.setRawData(items);
      }).catch(error => {
        this.duplicationCheck = false;
        console.log(error);
      });
    },
    onGridSingleButtonClicked(value, dataRow) {
      const inputValue = dataRow.authRequestReason;
      utils.openTextAreaEditor(
        this.onClosePopup,
        {
          title: this.$t('MSG_TXT_AUTH_APPL_RSN'),
          pageInitialData: {
            readonly: true,
            value: inputValue,
            positiveButtonText: this.$t('MSG_BTN_CFRM'),
          },
        }
      );
    },
    onGridStateClicked(stateOption, dataRow) {
      const inputValue = dataRow.authRejectReason;
      utils.openTextAreaEditor(
        this.onClosePopup,
        {
          title: this.$t('MSG_TIT_AUTH_APPL_RJT_RSN'),
          pageInitialData: {
            readonly: true,
            value: inputValue,
            positiveButtonText: this.$t('MSG_BTN_CFRM'),
          },
        }
      );
    },
    onClosePopup() {
      // 팝업 종료
    },
    onCancel() {
      if (this.dsData.data.length > 0) {
        const paramList = [];
        utils.forEach(this.dsData.data, obj => {
          if (utils.isEqual(obj.check, 'Y') === true) {
            paramList.push({
              authRequestReason: obj.authRequestReason || '',
              authRequestStatusCode: 'Z',
              authRequestUid: obj.authRequestUid,
            });
          }
        });

        if (paramList.length > 0) {
          utils.messageBox('confirm', this.$t('MSG_ALT_WANT_CANCEL_RQS'), null, () => {
            http.request(this.$options.name, 'DTS_CMA_00037', {
              path: { 'request-id': this.userInfo.userId },
              data: paramList,
            }).then(() => {
              this.searchData();
            }).catch(error => {
              console.log(error);
            });
          });
        } else {
          utils.messageBox('warning', this.$t('MSG_ALT_NOT_SEL_ITEM'));
        }
      } else {
        utils.messageBox('warning', this.$t('MSG_ALT_NOT_SEL_ITEM'));
      }
    },
    onSelectAll(event) {
      if (utils.isEqual(event.args.datafield, 'check')) {
        if (0 < this.dsData.data.length) {
          let count = 0;
          if (this.allSelect === false) {
              utils.forEach(this.dsData.data, obj => {
                if (utils.isEqual(obj.authRequestStatusCode, 'S') === true) {
                  this.dsData.setData(count, 'check', 'Y');
                }
                count = count + 1;
              });
              this.allSelect = true;
          }
          else {

            utils.forEach(this.dsData.data, obj => {
              if (utils.isEqual(obj.authRequestStatusCode, 'S') === true) {
                this.dsData.setData(count, 'check', 'N');
              }
              count = count + 1;
            });

            this.allSelect = false;
          }
        }
      }
    }
  },
};
</script>
<style scoped>
</style>
